import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-dash-card',
  templateUrl: './dash-card.component.html',
  styleUrls: ['./dash-card.component.css']
})
export class DashCardComponent implements OnInit {

  constructor() { }
  @Input() image;
  @Input() title;
  @Input() stats;
  @Input() info;
  @Input() link;
  @Input() index;
  @Output() routeAction = new EventEmitter();





  ngOnInit() {
  }

  route(data) {
    this.routeAction.emit(data);
  }
 
}
